export const getFormattedName = (client) => {
    return `${client.lastName ? client.lastName : ''}${client.firstName && client.lastName ? ', ' : ''}${client.firstName ? client.firstName : ''}`;
}

export const getFormattedNameCard = (client) => {
    return `${client.firstName ? client.firstName : ''} ${client.lastName ? client.lastName : ''}`;
}